import React from 'react'
import './rangeField.less'
import {useIntl} from 'react-intl'
import {DatabasePlantRecordField} from '../../../entities/plant'
import {Col, Form, Input, InputNumber, Row, Space} from 'antd'

export type RangeFieldProps = {
  fieldName: string
  fieldKeyFrom: string
  filedFrom: DatabasePlantRecordField
  fieldKeyTo: string
  fieldTo: DatabasePlantRecordField
}

export function RangeField(props: RangeFieldProps) {
  const intl = useIntl()

  return (
    <div className="ant-form-item">
      <Row className="edit-plant-form__range-field">
        <Col md={8} className="edit-plant-form__range-field-label">
          <label htmlFor={props.fieldKeyFrom}>{intl.formatMessage({id: props.fieldName})}</label>
        </Col>
        <Col md={16}>
          <Space.Compact block>
            <Form.Item key={props.fieldKeyFrom} name={props.fieldKeyFrom} noStyle>
              <InputNumber addonAfter="-" className="edit-plant-form__range-field-input-wrapper" />
            </Form.Item>
            <Form.Item key={props.fieldKeyTo} name={props.fieldKeyTo} noStyle>
              <InputNumber className="edit-plant-form__range-field-input-wrapper" />
            </Form.Item>
          </Space.Compact>
        </Col>
      </Row>
    </div>
  )
}
